import "core-js/modules/es.json.parse.js";
import SafetyCodeInput from "../Common/SafetyCodeInput.vue";
import { validateMFA } from "@/service/version";
import Cookies from "js-cookie";
export default {
  name: "ValidMFA",
  components: {
    SafetyCodeInput
  },
  props: {
    unitName: {
      type: String
    },
    unitCode: {
      type: String
    }
  },
  data() {
    return {
      showAuthMFA: false,
      validForm: {
        validCode: ""
      },
      issuer: null,
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
    };
  },
  methods: {
    open(issuer) {
      this.issuer = issuer;
      this.showAuthMFA = true;
      this.$refs.validForm.resetData();
    },
    close() {
      this.showAuthMFA = false;
    },
    handleSubmitAuthMFA() {
      this.$refs.validForm.validate(async data => {
        if (data.valid) {
          let res = await validateMFA({
            code: data.code,
            unitId: Cookies.get("unitId")
          });
          let {
            result
          } = res.data;
          if (result === 0) {
            this.$emit("validSuccess");
            this.close();
          }
        }
      });
    },
    handleCancelAuthMFA() {
      this.$emit("validCancel");
      this.close();
    }
  },
  mounted() {}
};